import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "asset-default-location-form" }
const _hoisted_2 = {
  key: 0,
  class: "alert alert-danger d-flex align-items-center gap-2 mb-4"
}
const _hoisted_3 = { class: "asset-info mb-4" }
const _hoisted_4 = { class: "text-muted" }
const _hoisted_5 = { class: "fw-bold" }
const _hoisted_6 = { class: "text-muted small" }
const _hoisted_7 = { class: "form-section mb-4" }
const _hoisted_8 = { class: "form-section-title mb-3" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-md-12 mb-3" }
const _hoisted_11 = {
  for: "street",
  class: "form-label"
}
const _hoisted_12 = ["placeholder"]
const _hoisted_13 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-md-6 mb-3" }
const _hoisted_16 = {
  for: "city",
  class: "form-label"
}
const _hoisted_17 = ["placeholder"]
const _hoisted_18 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_19 = { class: "col-md-6 mb-3" }
const _hoisted_20 = {
  for: "postalCode",
  class: "form-label"
}
const _hoisted_21 = ["placeholder"]
const _hoisted_22 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-md-12 mb-3" }
const _hoisted_25 = {
  for: "country",
  class: "form-label"
}
const _hoisted_26 = { value: null }
const _hoisted_27 = ["value"]
const _hoisted_28 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col-md-12 mb-3" }
const _hoisted_31 = ["disabled"]
const _hoisted_32 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}
const _hoisted_33 = {
  key: 1,
  class: "bi bi-geo-alt-fill me-2"
}
const _hoisted_34 = {
  key: 0,
  class: "text-muted d-block mt-1"
}
const _hoisted_35 = {
  key: 1,
  class: "alert alert-danger alert-sm mt-2 mb-0"
}
const _hoisted_36 = { class: "form-section" }
const _hoisted_37 = { class: "form-section-title mb-3" }
const _hoisted_38 = { class: "row" }
const _hoisted_39 = { class: "col-md-6 mb-3" }
const _hoisted_40 = {
  for: "lat",
  class: "form-label"
}
const _hoisted_41 = ["placeholder"]
const _hoisted_42 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_43 = { class: "col-md-6 mb-3" }
const _hoisted_44 = {
  for: "lng",
  class: "form-label"
}
const _hoisted_45 = ["placeholder"]
const _hoisted_46 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_47 = {
  key: 0,
  class: "row mt-3"
}
const _hoisted_48 = { class: "col-md-12" }
const _hoisted_49 = ["href"]
const _hoisted_50 = ["disabled"]
const _hoisted_51 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createBlock(_component_base_modal, {
    ref: "modalRef",
    nested: false,
    size: "md"
  }, {
    header: _withCtx(() => [
      _createElementVNode("h4", null, _toDisplayString(_ctx.$t('components.assets.defaultLocation.title')), 1)
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.errorMessage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _cache[12] || (_cache[12] = _createElementVNode("i", { class: "bi bi-exclamation-triangle-fill" }, null, -1)),
              _createElementVNode("span", null, _toDisplayString(_ctx.errorMessage), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h6", _hoisted_4, _toDisplayString(_ctx.$t('components.assets.defaultLocation.assetInfo')), 1),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.assetName), 1),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('components.assets.dataGrids.serialNumber')) + ": " + _toDisplayString(_ctx.assetSerialNumber), 1)
        ]),
        _createElementVNode("form", {
          onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("h6", _hoisted_8, [
              _cache[13] || (_cache[13] = _createElementVNode("i", { class: "bi bi-search me-2" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assets.defaultLocation.searchByAddress')), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('components.assetGroups.modal.fields.street')), 1),
                _withDirectives(_createElementVNode("input", {
                  id: "street",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.address.street) = $event)),
                  type: "text",
                  class: _normalizeClass(["form-control", { 'is-invalid': _ctx.addressValidationErrors.street }]),
                  placeholder: _ctx.$t('components.assetGroups.modal.placeholders.street')
                }, null, 10, _hoisted_12), [
                  [_vModelText, _ctx.address.street]
                ]),
                (_ctx.addressValidationErrors.street)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.addressValidationErrors.street), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('components.assetGroups.modal.fields.city')), 1),
                _withDirectives(_createElementVNode("input", {
                  id: "city",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.address.city) = $event)),
                  type: "text",
                  class: _normalizeClass(["form-control", { 'is-invalid': _ctx.addressValidationErrors.city }]),
                  placeholder: _ctx.$t('components.assetGroups.modal.placeholders.city')
                }, null, 10, _hoisted_17), [
                  [_vModelText, _ctx.address.city]
                ]),
                (_ctx.addressValidationErrors.city)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.addressValidationErrors.city), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('components.assetGroups.modal.fields.postalCode')), 1),
                _withDirectives(_createElementVNode("input", {
                  id: "postalCode",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.address.postalCode) = $event)),
                  type: "text",
                  class: _normalizeClass(["form-control", { 'is-invalid': _ctx.addressValidationErrors.postalCode }]),
                  placeholder: _ctx.$t('components.assetGroups.modal.placeholders.postalCode')
                }, null, 10, _hoisted_21), [
                  [_vModelText, _ctx.address.postalCode]
                ]),
                (_ctx.addressValidationErrors.postalCode)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.addressValidationErrors.postalCode), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t('components.assetGroups.modal.fields.country')), 1),
                _withDirectives(_createElementVNode("select", {
                  id: "country",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.address.country) = $event)),
                  class: _normalizeClass(["form-select", { 'is-invalid': _ctx.addressValidationErrors.country }])
                }, [
                  _createElementVNode("option", _hoisted_26, _toDisplayString(_ctx.$t('components.assetGroups.modal.selectCountry')), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (countryName, countryKey) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: countryKey,
                      value: countryKey
                    }, _toDisplayString(countryName), 9, _hoisted_27))
                  }), 128))
                ], 2), [
                  [_vModelSelect, _ctx.address.country]
                ]),
                (_ctx.addressValidationErrors.country)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(_ctx.addressValidationErrors.country), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-outline-primary btn-sm",
                  disabled: _ctx.loadingGeocode || !_ctx.address.street || !_ctx.address.city || !_ctx.address.postalCode || !_ctx.address.country,
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleGeocode && _ctx.handleGeocode(...args)))
                }, [
                  (_ctx.loadingGeocode)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_32))
                    : (_openBlock(), _createElementBlock("i", _hoisted_33)),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assetGroups.modal.geocodeButton')), 1)
                ], 8, _hoisted_31),
                (!_ctx.geocodeError)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_34, _toDisplayString(_ctx.$t('components.assets.defaultLocation.geocodeHint')), 1))
                  : _createCommentVNode("", true),
                (_ctx.geocodeError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                      _cache[14] || (_cache[14] = _createElementVNode("i", { class: "bi bi-exclamation-triangle-fill me-2" }, null, -1)),
                      _createElementVNode("span", null, _toDisplayString(_ctx.geocodeError), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("h6", _hoisted_37, [
              _cache[15] || (_cache[15] = _createElementVNode("i", { class: "bi bi-geo-alt me-2" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assets.defaultLocation.coordinates')), 1)
            ]),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.$t('components.assetGroups.modal.fields.latitude')), 1),
                _withDirectives(_createElementVNode("input", {
                  id: "lat",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.defaultLatitude) = $event)),
                  type: "number",
                  step: "0.00000001",
                  class: _normalizeClass(["form-control", { 'is-invalid': _ctx.coordinatesValidationErrors.latitude }]),
                  placeholder: _ctx.$t('components.assetGroups.modal.placeholders.latitude'),
                  min: "-90",
                  max: "90",
                  onBlur: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.validateCoordinates && _ctx.validateCoordinates(...args)))
                }, null, 42, _hoisted_41), [
                  [
                    _vModelText,
                    _ctx.form.defaultLatitude,
                    void 0,
                    { number: true }
                  ]
                ]),
                (_ctx.coordinatesValidationErrors.latitude)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, _toDisplayString(_ctx.coordinatesValidationErrors.latitude), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.$t('components.assetGroups.modal.fields.longitude')), 1),
                _withDirectives(_createElementVNode("input", {
                  id: "lng",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.defaultLongitude) = $event)),
                  type: "number",
                  step: "0.00000001",
                  class: _normalizeClass(["form-control", { 'is-invalid': _ctx.coordinatesValidationErrors.longitude }]),
                  placeholder: _ctx.$t('components.assetGroups.modal.placeholders.longitude'),
                  min: "-180",
                  max: "180",
                  onBlur: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.validateCoordinates && _ctx.validateCoordinates(...args)))
                }, null, 42, _hoisted_45), [
                  [
                    _vModelText,
                    _ctx.form.defaultLongitude,
                    void 0,
                    { number: true }
                  ]
                ]),
                (_ctx.coordinatesValidationErrors.longitude)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_46, _toDisplayString(_ctx.coordinatesValidationErrors.longitude), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_ctx.hasValidCoordinates)
              ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("a", {
                      href: _ctx.googleMapsUrl,
                      target: "_blank",
                      rel: "noopener noreferrer",
                      class: "btn btn-outline-success btn-sm"
                    }, [
                      _cache[16] || (_cache[16] = _createElementVNode("i", { class: "bi bi-geo-alt-fill me-2" }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assets.defaultLocation.checkOnMap')) + " ", 1),
                      _cache[17] || (_cache[17] = _createElementVNode("i", { class: "bi bi-box-arrow-up-right ms-2" }, null, -1))
                    ], 8, _hoisted_49)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ], 32)
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-secondary",
        onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
      }, _toDisplayString(_ctx.$t('components.assetGroups.modal.cancel')), 1),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary",
        disabled: _ctx.loading,
        onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)))
      }, [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_51))
          : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assetGroups.modal.update')), 1)
      ], 8, _hoisted_50)
    ]),
    _: 1
  }, 512))
}